import { render, staticRenderFns } from "./LicensesTable.vue?vue&type=template&id=d659cbce"
import script from "./LicensesTable.vue?vue&type=script&lang=js"
export * from "./LicensesTable.vue?vue&type=script&lang=js"
import style0 from "./LicensesTable.vue?vue&type=style&index=0&id=d659cbce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports